export default __webpack_public_path__ + "static/media/potato1.b14ed361.png";